export const enum QuoteLayout {
  List = "list",
  Grid = "grid",
}
